import React from 'react';
import { IOption } from '../HouseType';
import styles from './HouseTypeMobile.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Button from '@/components/UI/button/Button';
import Checkbox from '@/components/UI/checkbox/Checkbox';
import Typography from '@/components/UI/typography/Typography';
type IHouseTypeMobile = {
  handleClose: () => void;
  options: IOption[];
  updateCheckStatus: (name: IOption['name']) => void;
  submitData: () => void;
  handleClean: (e) => void;
  hasHouseTypeFilter: boolean;
  selectedFilters: Partial<Record<IOption['name'], undefined | 1>>;
};
const HouseTypeMobile = ({
  handleClose,
  options,
  updateCheckStatus,
  submitData,
  handleClean,
  hasHouseTypeFilter,
  selectedFilters
}: IHouseTypeMobile) => {
  return <Box className={styles['house-type-mobile-container']} data-sentry-element="Box" data-sentry-component="HouseTypeMobile" data-sentry-source-file="HouseTypeMobile.tsx">
      <Box className={styles['house-type-header']} data-sentry-element="Box" data-sentry-source-file="HouseTypeMobile.tsx">
        <Box onClick={handleClose} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="HouseTypeMobile.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="HouseTypeMobile.tsx" />
        </Box>
        <Typography variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="HouseTypeMobile.tsx">نوع اقامتگاه</Typography>
      </Box>
      <Box className={styles['house-type-checkbox-section']} data-sentry-element="Box" data-sentry-source-file="HouseTypeMobile.tsx">
        {options.map(item => <Checkbox key={item.name} label={item.label} checked={!!selectedFilters?.[item.name]} onChange={() => {
        updateCheckStatus(item.name);
      }} />)}
      </Box>
      <Box className={styles['house-type-button']} data-sentry-element="Box" data-sentry-source-file="HouseTypeMobile.tsx">
        <Button format="text" onClick={handleClean} data-sentry-element="Button" data-sentry-source-file="HouseTypeMobile.tsx">
          حذف همه
        </Button>
        <Button format="primary" onClick={submitData} disabled={!Object.keys(selectedFilters).length} data-sentry-element="Button" data-sentry-source-file="HouseTypeMobile.tsx">
          مشاهده نتایج
        </Button>
      </Box>
    </Box>;
};
export default HouseTypeMobile;